import React from 'react'
import createIcon from '@/lib/create-icon'

export const WebhookSVGIcon = createIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <g clipPath="url(#clip0_8928_120316)">
      <path d="M3.062 11C1.83229 11.6824 1 12.994 1 14.5C1 16.7091 2.79086 18.5 5 18.5C7.20914 18.5 9 16.7091 9 14.5H15M10 5.5L13.0571 11.0027C13.6323 10.6825 14.2949 10.5 15 10.5C17.2091 10.5 19 12.2909 19 14.5C19 16.7091 17.2091 18.5 15 18.5C14.0541 18.5 13.1848 18.1716 12.5 17.6227M14 5.5C14 3.29086 12.2091 1.5 10 1.5C7.79086 1.5 6 3.29086 6 5.5C6 7.004 6.83007 8.3141 8.0571 8.9973L5.00023 14.5H5.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_8928_120316">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>,
)
